

import { useCallback, useMemo } from 'react'
import { 
  useGetCustomersQuery as getCustomersQuery,
  useGetCustomerQuery as getCustomerQuery,
  useGetNoVisitReasonsQuery as getNoVisitReasonsQuery } from '../../../api/plamo-api'
import { Link } from 'react-router-dom'
import { ActionTableState } from '../action-table/action-table'

function NoVisitReasonTable({ preselectedEmployeeClosureId }: any) {
  
  const columns = useMemo(() => [
    {
      title: "Kunde",
      dataIndex: "customerId",
      type: 'reference',
      typeAttrs: {
        referenceList: () => getCustomersQuery({ o: 0, c: 1000, st: JSON.stringify({ name: 'asc' }), f: JSON.stringify({}) }),
        referenceSingle: id => getCustomerQuery({ id }),
        referenceDisplayString: customer => `${customer.firstName} ${customer.lastName}`,
        referenceLabel: customer => <Link to={`/customer/${customer.id}`}>{customer.firstName} {customer.lastName}</Link>,
        referenceGetId: customer => customer.id
      },      
    },
    {
      title: "Grund",
      dataIndex: "reason"
    },
  ], [])

  const applyPreselectedToFilter = useCallback(f => {
    const obj = JSON.parse(f);
    if(preselectedEmployeeClosureId) {
      obj["employeeClosure.id"] ={
        c: "EQ",
        v: preselectedEmployeeClosureId
      }
    }

    return JSON.stringify(obj);
  }, [preselectedEmployeeClosureId])

  return (
    <>
    <div>
    <ActionTableState
          isParentLoading={false}
          tableData={{
            defaultSortKey: 'id',
            defaultSortDirection: 'desc',
            columns,
            dataSource: {
              pageableQueryEndpoint: ({ f, ...rest }) => getNoVisitReasonsQuery({ f: applyPreselectedToFilter(f), ...rest }),
              queryResultMapping: (result) => result?.items
            },
          }}
        />
    </div>
    </>
    
  )
}

export default NoVisitReasonTable